import { apiForPrivate } from '.';
import { CLIENT_GROUP_ENDPOINT } from '../../config/ap';

const apiClientGroups = apiForPrivate.injectEndpoints({

    overrideExisting: true,
    
    endpoints: build => ({
        getClientGroup: build.query({
            query: id => `${CLIENT_GROUP_ENDPOINT.CLIENT_GROUPS}/${id}`,
        }),
        getClientGroups: build.query({
            query: page => ({
                url: `${CLIENT_GROUP_ENDPOINT.CLIENT_GROUPS}`,
                params: page
            })
        }),
        addClientGroup: build.mutation({
            query: payload => ({
                url: CLIENT_GROUP_ENDPOINT.CLIENT_GROUPS,
                method: 'POST',
                body: payload,
            }),
        }),
        updateClientGroup: build.mutation({
            query: ({ id, payload }) => ({
                url: `${CLIENT_GROUP_ENDPOINT.CLIENT_GROUPS}/${id}`,
                method: 'PUT',
                body: payload,
            }),
        }),
    })
});

export const {
    useLazyGetClientGroupQuery,
    // useLazyGetClientGroupsQuery,
    useGetClientGroupsQuery,
    useAddClientGroupMutation,
    useUpdateClientGroupMutation,
} = apiClientGroups;